export const projectsData = [
  {
    id: 'brand',
    number: '01',
    title: 'Brand Identity Kit',
    category: 'Branding',
    year: '2024',
    desc: 'Designed complete branding kits including logo, color palette, and typography for multiple clients.',
    tags: ['Logo Design', 'Color Palette', 'Typography'],
    color: '#e63946',
    images: [
      '/projects/brand/img1.png',
      '/projects/brand/img2.png',
      '/projects/brand/img3.png',
      '/projects/brand/img4.png',
      '/projects/brand/img5.png',
    ],
  },
  {
    id: 'social',
    number: '02',
    title: 'Social Media Campaign',
    category: 'Digital Design',
    year: '2024',
    desc: 'Created engaging social media creatives and campaigns that drove business growth and audience engagement.',
    tags: ['Social Media', 'Canva', 'Content Design'],
    color: '#A259FF',
    images: [
      '/projects/social/img1.png',
      '/projects/social/img2.png',
      '/projects/social/img3.png',
    ],
  },
  {
    id: 'print',
    number: '03',
    title: 'Print Design Collection',
    category: 'Print',
    year: '2023',
    desc: 'Developed print-ready designs for marketing materials including brochures, business cards and posters.',
    tags: ['Brochure', 'Business Cards', 'Posters'],
    color: '#FF9A00',
    images: [
      '/projects/print/img1.png',
      '/projects/print/img2.png',
      '/projects/print/img3.png',
    ],
  },
  {
    id: 'packaging',
    number: '04',
    title: 'Packaging & Promo Design',
    category: 'Packaging',
    year: '2023',
    desc: 'Worked on packaging and promotional designs that enhanced brand visibility and product appeal.',
    tags: ['Packaging', 'Promotional', 'Adobe Illustrator'],
    color: '#00C4CC',
    images: [
      '/projects/packaging/img1.png',
      '/projects/packaging/img2.jpeg',
      '/projects/packaging/img3.jpeg',
    ],
  },
  {
    id: 'client',
    number: '06',
    title: 'Client Branding Solutions',
    category: 'Branding',
    year: '2024',
    desc: 'Collaborated with clients to deliver tailored design solutions maintaining brand consistency.',
    tags: ['Client Work', 'Branding', 'Canva'],
    color: '#ff6b6b',
    images: [
      '/projects/client/img1.png',
      '/projects/client/img2.png',
      '/projects/client/img3.png',
    ],
  },
];